import { AngebotSparte } from '@mng/sales-types';
import { Antragdata } from '../../antrag.model.types';

export const antragdataMitBeratungVerzicht: Antragdata = {
  personen: [
    {
      id: '727766',
      stammdaten: {
        partnerNr: 727766,
        gebdatum: '1978-05-14',
        vorname: 'Josef',
        name: 'Huber'
      },
      juristischePerson: false,
      identifikationsnachweis: {
        ausweisart: 'FUEHRERSCHEIN',
        ausweisNr: 'VA/F-4901/AA',
        ausstellungsdatum: '1997-09-24',
        ausstellendeBehoerde: 'BPD Graz'
      },
      tarife: ['11560'],
      personRollen: {
        vp: true,
        vn: true,
        praemienzahler: true,
        praemienzahlerReason: 'Der VN ist auch der Prämienzahler'
      },
      veranlagungBeratung: {
        veranlagungsProfil: {
          aktien: 1,
          wertpapiere: null,
          anleihe: null,
          sonstige: null
        },
        anlageziele: {
          zielemotive: null
        },
        anlagehorizont: {
          horizont: null
        },
        finanzmoeglichkeiten: {
          veranlagungsBetrag: null
        },
        vermoegensanteil: {
          vermoegensProzentanteil: null
        },
        risikobereitschaft: {
          persoenlichesRisiko: null
        },
        beratungsverzicht: {
          verzichtetAufBeratung: true,
          unagemessenesProduktAusgewaehlt: null,
          unangemessenesProdukt: {
            risikoUnpassend: null,
            finanzverhaeltnisseUnpassend: null,
            sonstigegruende: null,
            sonstigesDesc: null
          }
        }
      }
    }
  ],
  angeboteMetaData: [
    {
      sparte: AngebotSparte.L,
      tarifInformationMetaData: {
        bezeichnung: 'L12AILD/2',
        tarifschluessel: '11560'
      },
      id: '3d42b034-8012-41ff-b2cc-9e52b3293434'
    }
  ]
};
